import React, { Component } from "react";

import { Wrapper, Card } from "app/NativeComponents/common";
import Feature from "./Feature";

class Features1Card extends Component {
  render() {
    const { onboarding_landing_page } = this.props;
    if (onboarding_landing_page && onboarding_landing_page.features) {
      return (
        <Wrapper
          style={{
            flexDirection: this.props.isMobile ? "column" : "row",
            alignItems: "center",
            justifyContent: "space-between",
            padding: 25
          }}
        >
          {onboarding_landing_page.features.map((feature, i) => {
            return (
              <Feature
                key={i}
                feature={feature.fields}
                isMobile={this.props.isMobile}
              />
            );
          })}
        </Wrapper>
      );
    }

    return <Wrapper />;
  }
}
export default Features1Card;
